<script>
  // # # # # # # # # # # # # # # #
  //
  //  Read link icon
  //
  // # # # # # # # # # # # # # # #
</script>

<style lang="scss">
  @import "../variables.scss";

  svg {
    display: block;
    height: 100%;
    margin-left: auto;
    margin-right: auto;

    @include screen-size("small") {
      width: 80%;
      max-width: 500px;
    }
  }

  .cls-1,
  .cls-3,
  .cls-4 {
    fill: none;
    stroke: #000;
    stroke-width: 1.5px;
  }
  .cls-2 {
    fill: $grey;
  }
  .cls-3 {
    stroke-dasharray: 4.83 4.83;
  }
  .cls-4 {
    stroke-dasharray: 4.71 4.71;
  }
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36.39 43.68">
  <g id="Layer_2" data-name="Layer 2">
    <g id="Layer_1-2" data-name="Layer 1">
      <path
        class="cls-1"
        d="M-3.7-17.7a2.42,2.42,0,0,0-2.47,2.47v29A2.42,2.42,0,0,0-3.7,16.2H15.15a2.42,2.42,0,0,0,2.47-2.47v-29a2.42,2.42,0,0,0-2.47-2.47Z"
        transform="translate(6.92 18.45)" />
      <path
        class="cls-2"
        d="M7.39-9.43A2.42,2.42,0,0,0,4.92-7V22a2.42,2.42,0,0,0,2.47,2.47H26.24A2.42,2.42,0,0,0,28.71,22V-7a2.42,2.42,0,0,0-2.47-2.47Z"
        transform="translate(6.92 18.45)" />
      <line class="cls-3" x1="11.84" y1="18.73" x2="11.84" y2="35.63" />
      <line class="cls-4" x1="21.38" y1="42.93" x2="28.45" y2="42.93" />
      <line class="cls-3" x1="35.64" y1="33.22" x2="35.64" y2="16.32" />
      <line class="cls-4" x1="26.1" y1="9.02" x2="19.03" y2="9.02" />
      <path
        class="cls-1"
        d="M9.75-9.43H7.39A2.42,2.42,0,0,0,4.92-7v2.42m23.79,0V-7a2.42,2.42,0,0,0-2.47-2.47H23.89m0,33.91h2.35A2.42,2.42,0,0,0,28.71,22V19.59m-23.79,0V22a2.42,2.42,0,0,0,2.47,2.47H9.75"
        transform="translate(6.92 18.45)" />
      <rect class="cls-2" x="6.92" y="18.45" width="9.25" height="15.24" />
      <polygon
        class="cls-2"
        points="8.41 29.1 15.99 29.1 15.99 31.25 22.41 25.97 15.99 20.7 15.99
        22.84 8.41 22.84 8.41 29.1" />
      <polygon
        class="cls-1"
        points="8.41 29.1 15.99 29.1 15.99 31.25 22.41 25.97 15.99 20.7 15.99
        22.84 8.41 22.84 8.41 29.1" />
    </g>
  </g>
</svg>
